module.exports = __webpack_public_path__ + "img/empty.a5753285.png";